<template>
    <div id="catalog">
        <headers :title='titles'></headers>
        <loadingS v-if='loading'></loadingS>
        <div class="content"
             v-if='!loading'>
            <div class="nav_list clearfix"
                 v-if="sid==11">
                <div @click="changeGrade(g.version_id)"
                     :class="['list_item',{'active':version_id==g.version_id}]"
                     v-for="g in navList"
                     :key="g.version_id">{{ g.name }}</div>
            </div>
            <noResouse v-if='!dataList.length'></noResouse>
            <div class="list-wrap">
                <ul>
                    <li class="video_item"
                        v-for="v in dataList"
                        :key="v.id">
                        <div class="video_icon"></div>
                        <div class="video_title">{{ v.name }}</div>
                        <div class="preview_btn"
                             @click="playVideo(v.video_url)">视频预览</div>
                        <div :class="['opt_btn',{'active':v.active}]"
                             @click="selected(v)">{{ v.active?'移除':'加入' }}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="foot"
             v-if='!loading'>
            <div class="bottom_btn clearfix">
                <div class="left_btn">
                    <i></i>
                    <span>已选（{{num}}项）</span>
                </div>
                <div v-if='num==0'
                     :class="['right_btn',{'able':num>0,'disable':num==0}]">去发布</div>
                <div v-else
                     :class="['right_btn',{'able':num>0,'disable':num==0}]"
                     @click="toSend">去发布</div>
            </div>
        </div>
        <videoPlayer v-if="!inApp"
                     ref="videoPlayer"
                     @closePlayer="closePlayer"
                     v-show="playFlag"
                     :video_url="video_url"
                     submit="1"></videoPlayer>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue'
import videoPlayer from 'SRC/components/base/videoPlayer.vue';  // 视频播放弹窗

export default {
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            type: this.$route.params.type, //视频的小分类
            sid: this.$route.params.sid,
            titles: decodeURIComponent(this.$route.query.title),
            dataList: [],
            qid: [], //所选的列表的id
            loading: true, //加载图
            num: 0,
            unclick: false, //防止双击
            navList: [],
            version_id: 1,
            video_url: '',
            playFlag: false
        }
    },
    created () {
        let _sendok = localStorage.getItem('chinese_send_ok');
        if (_sendok == 1) {
            this.$router.go(-1);//发布过返回选内容
            return;
        }
        if (this.sid != 11) {
            this.getData();
        } else {
            this.$http.post(API_URL_TASK_API + '/szyz/send/video_preview', {
                "type": this.type
            }).then(resp => {
                let res = resp.data;
                if (res.response === 'ok') {
                    if (res.data.length) {
                        this.version_id = res.data[0].version_id;
                        this.navList = res.data;
                        this.getData();
                    } else {
                        this.loading = false;
                    }
                } else {
                    layer.tips(res.message);
                    this.loading = false;
                }
            })
        }
    },
    components: {
        headers,
        loadingS,
        noResouse,
        videoPlayer
    },

    computed: {
        cid () {
            return this.$store.state.chinese.chapterid.join(',')
        }
    },
    destroyed () {

    },
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        toSend () {
            if (this.num > 100) {
                layer.alert('最多发送100个视频作业，请先移除部分视频。');
                return false;
            }
            if (!this.unclick) {
                this.dataList.forEach((item) => {
                    if (item.active) {
                        this.qid.push(item.id)
                    }
                });
                this.unclick = true;
            }
            this.$store.commit('setszyzreleaseid', this.qid)
            this.$router.push(`/qualityStation/release/${this.sid}/${this.type}`);
        },
        selected (d) {
            if (!d.active) {
                this.num += 1
            } else {
                this.num -= 1
            }
            d.active = !d.active;
        },
        changeGrade (id) {
            this.version_id = id;
            layer.open({ type: 2, shadeClose: false });
            this.getData();
        },
        getData () {
            this.$http.get(`${API_URL_TASK_API}/szyz/send/video_preview?type=${this.type}&version_id=${this.version_id}`).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    if (res.data.length) {
                        res.data.forEach(item => {
                            item.active = false;
                        })
                    }
                    this.dataList = res.data;
                } else {
                    layer.tips(res.message);
                }
            }).finally(() => {
                this.loading = false;
                layer.closeAll();
            })
        },
        playVideo (url) {
            if (this.inApp) {
                this.appFunction("ys_video", `${url},1`);
            } else {
                this.video_url = url;
                this.playFlag = true;
                this.$nextTick(() => {
                    this.$refs.videoPlayer.play();
                })
            }
        },
        /**退出视频 */
        closePlayer () {
            this.playFlag = false;
        },
    }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
#catalog {
    min-height: 100vh;
    .content {
        padding-bottom: 2.8rem;
        .nav_list {
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            background-color: #fff;
            margin-bottom: 24px / $ppr;
            font-size: 26px / $ppr;
            color: #999;
            text-align: center;
            .list_item {
                float: left;
                padding: 0 24px / $ppr;
                &.active {
                    font-size: 30px / $ppr;
                    color: #333;
                    position: relative;
                    font-weight: bold;
                    &::after {
                        content: "";
                        display: block;
                        position: absolute;
                        width: 48px / $ppr;
                        height: 6px / $ppr;
                        border-radius: 3px / $ppr;
                        background-color: #5e89ef;
                        bottom: 18px / $ppr;
                        left: 50%;
                        margin-left: -24px / $ppr;
                    }
                }
            }
        }
        .prompting {
            position: relative;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 24px / $ppr;
            color: #5e89ef;
            text-align: center;
            background-color: #fff;
            i {
                display: block;
                position: absolute;
                top: 36px / $ppr;
                right: 40px / $ppr;
                color: #cbcbcb;
            }
        }

        .list-wrap {
            background-color: #fff;
            .video_item {
                height: 120px / $ppr;
                border-bottom: 1px / $ppr solid #dcdcdc;
                display: flex;
                align-items: center;
                padding: 0 24px / $ppr;
                overflow: hidden;
                &:last-child {
                    border-bottom: none;
                }
                .video_icon {
                    width: 44px / $ppr;
                    height: 45px / $ppr;
                    margin-right: 20px / $ppr;
                    flex-shrink: 0;
                    background-image: url("./img/img_icon_01.png");
                    background-size: 100% 100%;
                }
                .video_title {
                    flex-grow: 1;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 300px / $ppr;
                }
                .preview_btn {
                    width: 177px / $ppr;
                    font-size: 24px / $ppr;
                    color: #5e89ef;
                    text-align: center;
                    flex-shrink: 0;
                }
                .opt_btn {
                    width: 118px / $ppr;
                    height: 44px / $ppr;
                    border: 1px solid #5e89ef;
                    color: #5e89ef;
                    text-align: center;
                    line-height: 44px / $ppr;
                    flex-shrink: 0;
                    border-radius: 22px / $ppr;
                    font-size: 24px / $ppr;
                    &.active {
                        border-color: #ff6600;
                        color: #ff6600;
                    }
                }
            }
        }
    }
    .foot {
        position: fixed;
        bottom: 0;
        width: 100%;
        .bottom_btn {
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 5;
            font-size: 30px / $ppr;
            text-align: center;
            .left_btn {
                width: 70%;
                float: left;
                background: #f0f0f0;
                color: #333;
                position: relative;
                i {
                    position: absolute;
                    z-index: 1;
                    top: 25px / $ppr;
                    display: inline-block;
                    width: 50px / $ppr;
                    height: 42px / $ppr;
                    background: url("./img/icon1.png") 0 0 no-repeat;
                    background-size: 100% 100%;
                }
                span {
                    font-size: 30px / $ppr;
                    color: #333;
                    display: inline-block;
                    padding-left: 60px / $ppr;
                }
            }
            .right_btn {
                width: 30%;
                float: right;
            }
            .able {
                color: #fff;
                background: #5e89ef;
            }
            .disable {
                color: #fff;
                background: #999;
            }
        }
    }
}
</style>
